import { render } from "./QuizView.vue?vue&type=template&id=3c169864&scoped=true"
import script from "./QuizView.vue?vue&type=script&lang=js"
export * from "./QuizView.vue?vue&type=script&lang=js"

import "./QuizView.vue?vue&type=style&index=0&id=3c169864&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c169864"]])

export default __exports__